import React from 'react'
import { SvgIconProps } from './Home'

const SvgParticipantsIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="17"
    fill="none"
    viewBox="0 0 20 17"
  >
    <path
      fill={fill ?? "#353535"}
      d="M18.9 12.4c-.4-1.2-1.7-1.7-2.7-2.1-.2-.1-.4-.1-.6-.2-.1 0-.3-.1-.5-.2s-.6-.2-.8-.3c.1-.2.3-.5.4-.7.1-.1.2-.3.3-.4 1.3-2.2 1.4-4.5.3-6.3C14.5.9 13 0 11.4 0c-.9 0-1.7.2-2.5.7-.4.2-.5.6-.4 1 0 .1.1.3.2.4-.3-.1-.6-.1-1-.1-2.6 0-4.8 2.2-4.8 5 0 2.1 1.2 4 1.7 4.6l-3.1 1.3c-.8.3-1.5 1.2-1.5 2.2 0 1 .8 1.9 1.9 1.9h11.6c1 0 1.9-.9 1.9-1.9v-.3c.2.1.3.2.6.2h.9c.3 0 .6 0 .8-.1.5-.1.9-.4 1.1-.9.2-.4.3-1 .1-1.6zm-13.4.8c.5-.2.9-.6 1-1.1.1-.5 0-1-.4-1.4 0 0-1.4-1.8-1.4-3.7 0-1.7 1.3-3.2 3-3.2s3 1.4 3 3.2c0 1.9-1.4 3.7-1.5 3.7-.3.4-.5 1-.4 1.5.1.5.5.9 1 1.1l3.4 1.4c.2.1.3.3.3.5 0 0 0 .1-.1.1H1.9v-.1c0-.2.2-.4.3-.5l3.3-1.5zm8.4-.3l-3.1-1.3c.5-.6 1.7-2.5 1.7-4.6 0-2.1-1.2-3.9-3-4.6.1 0 .2-.1.3-.1.5-.3 1-.4 1.5-.4.8 0 1.6.3 2.2 1 .6.6.9 1.5.9 2.4-.1.9-.4 1.9-1.1 2.9-.1.1-.1.2-.2.3-.3.4-.7.9-.6 1.6.1.9.9 1.2 1.4 1.4.3.1.6.2.9.4.3.1.6.3.9.4.1 0 .3.1.4.1.4.1.8.3.9.5 0 0 .1.2.1.3 0 .1-.2.1-.3.1h-.9c-.5 0-.8.3-.9.8-.2-.6-.6-1-1.1-1.2z"
    ></path>
  </svg>
)


export default SvgParticipantsIcon